import commonApi from '@/api/api.common'
import i18n from '@/locales/index'
export default [
  {
    type: 'input',
    placeholder: i18n.t('Device.deviceCode'),
    filed: 'code',
    default: ''
  },
  {
    type: 'select',
    placeholder: i18n.t('Device.isInExpirationDate'),
    filed: 'isInExpirationDate',
    default: '',
    options: [
      {
        //在保
        code: 'Y',
        name: i18n.t('Device.isInExpirationDateY')
      },
      {
        //过保
        code: 'N',
        name: i18n.t('Device.isInExpirationDateN')
      },
      {
        //未登记
        code: 'U',
        name: i18n.t('Device.isInExpirationDateU')
      }
    ]
  },
  {
    type: 'select',
    placeholder: i18n.t('Device.onLineStatus'),
    filed: 'deviceListOnline',
    default: '',
    query: commonApi.device_online_select
  },
  {
    type: 'select',
    placeholder: i18n.t('Device.deviceStatus'),
    // filed: 'state',
    filed: 'deviceListState',
    default: '',
    query: commonApi.device_state_select
  },
  {
    type: 'input',
    placeholder: i18n.t('Device.customerName'),
    filed: 'customerName',
    default: ''
  }
]
